export const PATCH_ONE_SWOT_ITEM = "PATCH_ONE_SWOT_ITEM"
export const DELETE_ONE_SWOT_ITEM = "DELETE_ONE_SWOT_ITEM"
export const LOADING_PATCH_SWOT_ITEM = "LOADING_PATCH_SWOT_ITEM"
export const SWOT_ITEM_FAIL = "ACTIONS_ITEM_FAIL"
export const CLEAR_SWOT_ITEM = "CLEAR_SWOT_ITEM"